import { ProductsServices } from './../products/services';
import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ToastController } from 'ionic-angular';
import { DishViewPage } from '../dish/dish-view/dish-view/dish-view';
import { DishListPage } from '../dish/dish-list/dish-list';
import { DishCreateNamePage } from '../dish/dish-create/dish-create-name/dish-create-name';
import { IngredientViewPage } from '../ingredients/ingredient-view/ingredient-view/ingredient-view';
import { IngredientCreateSelectType } from '../ingredients/ingredient-create-select-type/ingredient-create-select-type';
import { ProductViewPage } from '../products/product-view/product-view/product-view';
import { ProductCreateSelectTypePage } from '../products/product-create/product-create-select-type/product-create-select-type';
import { DeliberyNoteViewPage } from '../delibery_note/delibery-note-view/delibery-note-view/delibery-note-view';
import { DeliberyNoteListPage } from '../delibery_note/delibery-note-list/delibery-note-list';
import { ProviderOrderListPage } from '../providers/orders/provider-order-list/provider-order-list';
import { DishServices } from '../dish/services';
import { HomePage } from '../home/home';
import { Globals } from '../../globals';
import { InvoicesServices } from '../invoices/services';
import { CurrencyPipe } from '@angular/common';
import { CustomersServices } from '../customers/services';
import { HttpClient } from '@angular/common/http';
import { PrintServices } from '../services/printServices';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../stock/stock-list/stock-list';
import { AddonsTriggerVersionProPage } from '../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DeliberyNoteCreateTypePage } from '../delibery_note/delibery-note-create/delibery-note-create-type/delibery-note-create-type';

/**
 * Generated class for the FinishProcessPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-finish-process',
  templateUrl: 'finish-process.html',
})
export class FinishProcessPage {

  public uid_element: any;
  public type: string;
  public origin: string;
  public ticket: any;
  public customer_uid: any;
  public update_state: boolean; // true si es edición, false si es creación

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public dishServices: DishServices,
    public productsServices: ProductsServices,
    public globals: Globals,
    public invoicesServices: InvoicesServices,
    public cp: CurrencyPipe,
    public customersServices: CustomersServices,
    public http: HttpClient,
    public printServices: PrintServices,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController) {

    this.uid_element = this.navParams.get('uid_element');
    this.type = this.navParams.get('type');
    this.origin = this.navParams.get('origin');
    this.ticket = this.navParams.get('ticket');
    this.customer_uid = this.navParams.get('customer_uid');
    this.update_state = this.navParams.get('update_state') || false; // Por defecto es false (creación)

  }

  async ionViewWillEnter() {
    await this.dishServices.getPagesDishes(50);
  }

  dish(section) {
    switch (section) {
      case 'view': {
        this.globals.tourLaunchStep(10);
        this.navCtrl.setRoot(DishViewPage, {
          dish_uid: this.uid_element
        });
        break;
      }
      case 'list': {
        this.navCtrl.setRoot(DishListPage);
        break;
      }
      case 'create': {
        var total_dishes = 0;
        if (this.dishServices._dishes_array_tmp) {
          total_dishes = this.dishServices._dishes_array_tmp.length;
        }
        //Si total_dishes es mayor o igual al limite de platos, y el limite es diferente a -1
        if (total_dishes >= this.globals.checkLimitsByLicense('dishes', 'max_dishes') && this.globals.checkLimitsByLicense('dishes', 'max_dishes') != -1) {
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.dishServices.image_url_dish_view = null;
          this.navCtrl.setRoot(DishCreateNamePage);
        }
        break;
      }

    }
  }

  ingredient(section) {
    switch (section) {
      case 'view': {
        this.navCtrl.setRoot(IngredientViewPage, {
          ingredient_uid: this.uid_element ,
          new_element : true
        });
        break;
      }
      case 'list': {
        this.navCtrl.setRoot(StockListPage);
        break;
      }
      case 'create': {

        if (this.globals.checkLimitsByLicense('stock', 'ings_prods') == -1) {
          this.navCtrl.push(IngredientCreateSelectType);
        } else {
          this.navCtrl.push(AddonsTriggerVersionProPage);
        }
        break;
      }

    }
  }

  product(section) {
    switch (section) {
      case 'view': {
        this.navCtrl.setRoot(ProductViewPage, {
          product_uid: this.uid_element
        });
        break;
      }
      case 'list': {
        this.navCtrl.setRoot(StockListPage);
        break;
      }
      case 'create': {
        this.productsServices.image_url_product_view = null;
        this.navCtrl.setRoot(ProductCreateSelectTypePage);
        break;
      }

    }
  }

  delibery_note(section) {
    switch (section) {
      case 'view': {
        // view_delibery_after_create es para hacer un set root a la pagina delibery-note-view y no perjudicar otras paginas
        this.navCtrl.setRoot(DeliberyNoteViewPage, {
          delibery_note_uid: this.uid_element,
          view_delibery_after_create : true
        });
        break;
      }
      case 'list': {
        this.navCtrl.setRoot(DeliberyNoteListPage);
        break;
      }
      case 'create': {
        this.navCtrl.setRoot(DeliberyNoteCreateTypePage);
        break;
      }
      case 'provider_order': {
        this.navCtrl.setRoot(ProviderOrderListPage);
        break;
      }

    }
  }

  backHome() {
    this.navCtrl.setRoot(HomePage);
  }

  async launchPrepareAndOption(option) {
    // loading
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-preparando')
    });
    loadingPopup.present();
    //get costumer
    var customer = await this.customersServices.getCustomer(this.customer_uid);
    //check if email (sino no es pot enviar el email)
    if (option === 'download') {
      this.invoicesServices.prepareAndOption(option, 'tpv', this.uid_element, this.customer_uid, this.ticket, []);
      //
      this.navCtrl.pop();
      this.navCtrl.pop();
      this.navCtrl.pop();
      loadingPopup.dismiss();
    } else {
      if (customer.email) {
        this.invoicesServices.prepareAndOption(option, 'tpv', this.uid_element, this.customer_uid, this.ticket, []);
        //
        this.navCtrl.pop();
        this.navCtrl.pop();
        this.navCtrl.pop();
        loadingPopup.dismiss();
      } else {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-cliente-no-email'),
          duration: 3000,
          position: 'bottom'
        });
        loadingPopup.dismiss();
        toast.present();
      }
    }
  }


  async printInvoice() {
    //
    var _tickets = [];
    //refund
    var refund_reason = '';
    if (this.ticket.refund_reason) {
      refund_reason = this.ticket.refund_reason;
    } else {
      refund_reason = '';
    }

    var _ticket = {
      'number': this.ticket.number + " (" + this.globals.timestampToDate(this.ticket.date) + ")",
      'amount': this.ticket.amount,
      'tip': this.ticket.tip,
      'refund_reason': refund_reason,
    }

    _tickets.push(_ticket);

    //get invoice
    var invoice_raw = await this.invoicesServices.getInvoice(this.uid_element);
    //get customer
    var customer_raw = await this.customersServices.getCustomer(this.customer_uid);

    //format invoice ticket
    this.invoicesServices.invoice_print = 'indv';
    this.invoicesServices.invoice_print_ind_number = invoice_raw.invoice_number;
    this.invoicesServices.invoice_print_ind_date = this.globals.timestampToDate(invoice_raw.created_at);
    this.invoicesServices.invoice_print_indv_tickets = _tickets;
    this.invoicesServices.invoice_print_indv_ticket_subtotal = invoice_raw.subtotal;
    this.invoicesServices.invoice_print_indv_ticket_iva = invoice_raw.iva;
    this.invoicesServices.invoice_print_indv_total_ticket = invoice_raw.total;
    this.invoicesServices.invoice_print_indv_cus_name = customer_raw.business_name;
    this.invoicesServices.invoice_print_indv_cus_address = customer_raw.address;
    this.invoicesServices.invoice_print_indv_cus_cif = customer_raw.business_number;
    this.invoicesServices.invoice_print_tips = this.ticket.tip;

    if (this.globals.restaurant.printer_type == 'native') {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('instant-imprimir-factura'),
        message: this.translate.instant('instant-seguro-quieres-imprimir-factura'),
        buttons: [
          {
            text: this.translate.instant('general-no'),
            role: 'cancel',
            handler: () => {
              //
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
            }
          },
          {
            text: this.translate.instant('general-si'),
            handler: () => {
              this.globals.print_content = document.getElementById('print_invoice');
              this.printServices.printNow('print_invoice');
              //
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
            }
          }
        ]
      });
      alert.present();
    } else {
      this.printServices.prepareInvoice(this.globals.restaurant.printer_type);
    }
  }

  backTPV() {
    this.navCtrl.pop();
    this.navCtrl.pop();
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/finish-process/finish-process.ts